import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { UserPhaseStatsOutput } from 'infrastructure/graphql/content/user/model/user-phase-stats.output';

import { ApiQuery } from '../../../../common/model/api.query';

export interface FetchUserPhasesStatsParams {
	readonly userId: string;
}

@Injectable({ providedIn: 'root' })
export class FetchUserPhasesStatsApiQuery extends ApiQuery<
	UserPhaseStatsOutput[],
	FetchUserPhasesStatsParams
> {
	client = 'content';
	document = gql`
		query FetchUserPhasesStats($userId: UUID!) {
			fetchUserPhasesStatistic(userId: $userId) {
				doneModulesCount
				modulesCount
				orgPhaseId
			}
		}
	`;
	method = 'fetchUserPhasesStatistic';
}
